import { ProMessage } from '../antd';

type NoticeType = 'info' | 'success' | 'error' | 'warning' | 'loading';
export function responseSuccess(res?: any) {
  ProMessage.success(typeof res === 'string' ?  res || '操作成功' : res?.message || '操作成功');
}
export function responseError(resp: any) {
  if (!resp) return ProMessage.error('操作失败');
  if (typeof resp === 'string') {
    return ProMessage.error(resp);
  }
  if (resp.message) {
    return ProMessage.error(resp.message);
  }
}
export function responseWarning(message: string) {
  ProMessage.warning(message);
}
export function responseMessage(type: NoticeType, message: any) {
  if (type === 'success') return responseSuccess(message);
  if (type === 'error') return responseError(message);
  return ProMessage[type](message);
}
